import { connect } from 'react-redux';
import ScribeReportModal from './ScribeReportModal';
const mapStateToProps = ({ scribeConversation: { id: conversationId, status } }) => ({
    conversationId,
    status,
});
export default connect(mapStateToProps, {})(ScribeReportModal);
